(ns frontend.view.workspaces.view
  (:require [common.localization :as loc]
            [frontend.routing :as routing]
            [frontend.state.current-session :as session]
            [frontend.view.workspaces.kyc-workspace :as kyc-workspace]))

(defmethod routing/render-view :workspace [{:keys [route-params view-params]}]
  (let [target-id (:workspace/target @session/target)
        target (get @session/entities target-id)]
    (case (:entity/type target)
      :entity.type/kyc-process [kyc-workspace/view target]
      [:div (loc/tr :unknown-workspace [target-id])])))
